import UserSettings from './Settings';

export {
  UserSettings
};


// WEBPACK FOOTER //
// ./src/views/User/index.js